var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"cyan darken-4"}}),_c('div',{staticClass:"text-center pt-2"},[_vm._v("Data Sedang Dimuat")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }